import React from 'react';
import styles from './LoadingSpinner.module.scss';

interface Props {
  label?: string;
  fullscreen?: boolean;
}

export const LoadingSpinner: React.FC<Props> = ({ label = 'Loading…', fullscreen = false }) => {
  return (
    <div
      className={fullscreen ? styles.fullscreen : styles.inline}
      role="status"
      aria-live="polite"
    >
      <div className={styles.spinner} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </div>
  );
};
